
import { ICycle } from '@/models/types/cycle';
import { INote } from '@/models/types/note';
import { ICatalogPlant } from '@/models/types/catalogPlant';
import { IPlant } from '@/models/types/plant';
import ZoomOutMobile from '@/utils/userHelpers/zoomOutMobile';
import { create } from 'zustand';

interface StateStore {

    globalLoading: boolean;
    setGlobalLoading: (loading: boolean) => void;
    dataLoading: boolean;
    setDataLoading: (loading: boolean) => void;
    dataHydrated: boolean;
    setDataHydrated: (hydrated: boolean) => void;
    dataError: string | null;
    setDataError: (error: string | null) => void;
    dataOwnerEmail: string;
    setDataOwnerEmail: (email: string) => void;
    clearAppData: () => void;
    userVerified: boolean;
    setUserVerified: (verified: boolean) => void;
    urlToUse: string;
    setUrlToUse: (url: string) => void;
    widthQuery: number;
    setWidthQuery: (width: number) => void;
    heightQuery: number;
    setHeightQuery: (height: number) => void;
    handleZoomReset: (screenWidth: number, max: boolean) => void;
    overlay: boolean;
    setOverlay: (overlay: boolean) => void;
    //
    currPlant: IPlant;
    setCurrPlant: (item: IPlant) => void;
    currCycle: ICycle;
    setCurrCycle: (item: ICycle) => void;
    currNote: INote;
    setCurrNote: (item: INote) => void;
    //
    plants: IPlant[];
    setPlants: (plants: IPlant[]) => void;
    //
    activelyGrowing: ICycle[];
    setActivelyGrowing: (activelyGrowing: ICycle[]) => void;
    //
    notes: INote[];
    setNotes: (notes: INote[]) => void;
    catalogPlants: ICatalogPlant[];
    setCatalogPlants: (plants: ICatalogPlant[]) => void;
    specificTab: number;
    setSpecificTab: (tab: number) => void;
}

export const useStateStore = create<StateStore>((set) => ({

    globalLoading: false,
    setGlobalLoading: (loading) => set({ globalLoading: loading }),
    dataLoading: false,
    setDataLoading: (loading) => set({ dataLoading: loading }),
    dataHydrated: false,
    setDataHydrated: (hydrated) => set({ dataHydrated: hydrated }),
    dataError: null,
    setDataError: (error) => set({ dataError: error }),
    dataOwnerEmail: '',
    setDataOwnerEmail: (email) => set({ dataOwnerEmail: email }),
    clearAppData: () => set({
        plants: [],
        activelyGrowing: [],
        notes: [],
        catalogPlants: [],
        currPlant: {} as IPlant,
        currCycle: {} as ICycle,
        currNote: {} as INote,
        dataHydrated: false,
        dataLoading: false,
        dataError: null,
        dataOwnerEmail: '',
        userVerified: false,
    }),
    userVerified: false,
    setUserVerified: (verified) => set({ userVerified: verified }),

    urlToUse: '',
    setUrlToUse: (url) => set({ urlToUse: url }),
    widthQuery: 0,
    setWidthQuery: (width) => set({ widthQuery: width }),
    heightQuery: 0,
    setHeightQuery: (height) => set({ heightQuery: height }),
    handleZoomReset: (width, m) => {
        ZoomOutMobile({ deviceWidth: width, max: m })
    },
    overlay: false,
    setOverlay: (overlayPassed) => set({ overlay: overlayPassed }),
    //
    currPlant: {} as IPlant,
    setCurrPlant: (item) => set({ currPlant: item }),
    currCycle: {} as ICycle,
    setCurrCycle: (item) => set({ currCycle: item }),
    currNote: {} as INote,
    setCurrNote: (item) => set({ currNote: item }),
    //
    plants: [] as IPlant[],
    setPlants: (plantsToSet) => set({ plants: [...plantsToSet] }),
    //
    activelyGrowing: [] as ICycle[],
    setActivelyGrowing: (activelyGrowingPassed) => set({ activelyGrowing: [...activelyGrowingPassed] }),
    //
    notes: [] as INote[],
    setNotes: (notesToSet) => set({ notes: [...notesToSet] }),
    catalogPlants: [] as ICatalogPlant[],
    setCatalogPlants: (catalogPlantsToSet) => set({ catalogPlants: [...catalogPlantsToSet] }),
    specificTab: 0,
    setSpecificTab: (tabPassed) => set({ specificTab: tabPassed })
}));
